const IntroSessionDecoration = () => (
    <svg
        width="398"
        height="150"
        viewBox="0 0 398 202"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M257.432 56.5511L261.934 32.5948C265.24 14.9993 282.212 3.26405 299.842 6.38337"
            stroke="black"
            strokeWidth="4.3551"
        />
        <path
            d="M250.418 35.0544L258.317 36.5337L252.723 64.9831L244.824 63.5038C242.696 63.1054 241.309 61.0609 241.727 58.9369L245.809 38.1791C246.226 36.0551 248.29 34.656 250.418 35.0544Z"
            fill="black"
            stroke="black"
            strokeWidth="0.87102"
        />
        <rect
            x="255.056"
            y="4.26196"
            width="95.9495"
            height="132.286"
            rx="47.9747"
            transform="rotate(8.32554 255.056 4.26196)"
            fill="#8DCAFF"
        />
        <path
            d="M282.186 44.5329C282.634 42.8204 281.494 41.0803 279.736 40.875C278.386 40.7173 277.105 41.5344 276.72 42.838C275.07 48.4292 274.659 52.26 274.985 57.6186C275.066 58.9536 276.111 60.0213 277.44 60.1765C279.205 60.3827 280.709 58.9241 280.657 57.1475C280.527 52.6486 280.979 49.1508 282.186 44.5329Z"
            fill="black"
        />
        <path
            d="M270.358 43.1435C270.805 41.431 269.666 39.6909 267.908 39.4856C266.558 39.3279 265.277 40.145 264.892 41.4486C263.242 47.0398 262.831 50.8706 263.157 56.2292C263.238 57.5642 264.283 58.6319 265.612 58.7871C267.377 58.9933 268.881 57.5347 268.829 55.7581C268.699 51.2592 269.151 47.7613 270.358 43.1435Z"
            fill="black"
        />
        <path
            d="M300.189 72.6558L294.658 72.5476L294.608 75.1289L294.55 78.079L299.72 77.8112L299.94 75.3883L300.189 72.6558Z"
            fill="black"
        />
        <path
            d="M320.196 68.2513C308.314 74.4069 306.455 76.1111 294.608 75.1289M300.189 72.6558L294.658 72.5476L294.55 78.079L299.72 77.8112L300.189 72.6558Z"
            stroke="black"
            strokeWidth="2.21297"
        />
        <path
            d="M324.765 68.4263L328.562 48.2238C332.258 28.5552 319.279 9.78396 299.572 6.29712"
            stroke="black"
            strokeWidth="4.3551"
        />
        <rect
            x="-0.348843"
            y="-0.504208"
            width="19.972"
            height="28.9945"
            rx="4.62849"
            transform="matrix(-0.984614 -0.174744 0.183615 -0.982998 331.062 83.5183)"
            fill="black"
            stroke="black"
            strokeWidth="0.87102"
        />
        <path
            d="M256.007 62.6628C266.987 66.5953 274.204 67.8825 286.988 67.1717C287.863 67.1231 288.592 67.8542 288.459 68.7195C286.817 79.373 277.339 87.3908 264.571 83.0546C253.768 79.3856 253.781 68.0346 254.197 63.7483C254.282 62.8687 255.175 62.3648 256.007 62.6628Z"
            fill="black"
        />
        <path
            d="M278.27 96.0599L266.48 95.8414C260.439 133.861 259.926 154.761 264.713 191.202L276.503 191.421C271.124 159.83 271.468 138.999 278.27 96.0599Z"
            fill="#8DCAFF"
        />
        <path
            d="M278.429 198.589C278.574 190.779 272.36 184.331 264.55 184.186L258.891 184.081C253.613 183.984 249.256 188.182 249.158 193.46L249.087 197.302C249.047 199.424 250.736 201.175 252.858 201.215L275.273 201.63C276.985 201.662 278.397 200.3 278.429 198.589Z"
            fill="#8DCAFF"
        />
        <path
            d="M306.705 101.424L294.033 103.042C293.127 141.592 295.64 162.346 306.111 197.651L318.783 196.033C308.387 165.62 305.704 144.959 306.705 101.424Z"
            fill="#8DCAFF"
        />
        <path
            d="M321.666 202.855C320.677 195.107 313.594 189.627 305.845 190.617L300.23 191.333C294.994 192.002 291.292 196.788 291.96 202.024L292.447 205.835C292.716 207.941 294.64 209.429 296.745 209.161L318.984 206.321C320.682 206.105 321.883 204.553 321.666 202.855Z"
            fill="#8DCAFF"
        />
        <path
            d="M307.281 109.7C309.618 107.712 310.246 104.359 308.79 101.658C306.782 97.9316 301.807 97.0935 298.629 99.8905C280.854 115.536 268.418 123.55 250.701 127.712C246.428 128.716 244.053 133.469 246.136 137.333C247.437 139.746 250.148 141.069 252.83 140.497C276.097 135.53 288.402 125.761 307.281 109.7Z"
            fill="#549FE0"
        />
        <path
            d="M250.146 86.7813C252.406 88.2978 255.421 88.0265 257.376 86.1333C260.074 83.5212 259.592 79.0718 256.438 77.0323C238.8 65.6235 228.964 56.9352 221.145 42.8109C219.258 39.4041 214.629 38.5207 211.831 41.2294C210.084 42.9211 209.607 45.555 210.741 47.7063C220.584 66.3756 231.888 74.5297 250.146 86.7813Z"
            fill="#8DCAFF"
        />
        <path
            d="M164.684 93.1451L159.748 72.1925C156.21 57.1744 141.139 47.7476 126.087 51.1371"
            stroke="black"
            strokeWidth="3.5329"
        />
        <path
            d="M166.083 76.2546L159.738 77.7482L165.333 100.593L171.679 99.0999C173.388 98.6975 174.435 96.9885 174.017 95.2829L169.935 78.6145C169.517 76.9088 167.792 75.8522 166.083 76.2546Z"
            fill="black"
            stroke="black"
            strokeWidth="0.706579"
        />
        <path
            d="M176.687 193.091L169.065 190.949C168.977 190.925 168.924 190.837 168.941 190.748L171.057 179.895C173.515 167.286 170.38 154.23 162.464 144.113L161.646 143.068L157.831 156.03C162.615 162.427 164.419 170.572 162.782 178.39L159.781 192.729C159.408 194.515 160.382 196.308 162.084 196.965L174.022 201.578C176.148 202.4 178.508 201.135 179 198.908L179.315 197.48C179.742 195.551 178.588 193.626 176.687 193.091Z"
            fill="#FFA726"
        />
        <path
            d="M108.747 185.454L111.733 177.907L122.616 181.547C132.307 184.789 142.032 176.726 140.641 166.602L140.053 162.327L130.618 160.166L131.574 164.715C132.737 170.246 127.465 174.954 122.1 173.177L110.305 169.27C108.587 168.701 106.709 169.449 105.853 171.044L100.123 181.718C99.0237 183.767 100.05 186.311 102.263 187.023L104.144 187.629C106.012 188.23 108.026 187.279 108.747 185.454Z"
            fill="#FFA726"
        />
        <path
            d="M169.927 85.8375C164.902 65.6967 144.501 53.4433 124.36 58.4687C104.219 63.4941 91.9659 83.8954 96.9913 104.036L111.63 162.707C112.473 166.083 115.572 168.42 119.047 168.232C142.441 166.968 157.608 163.355 180.564 152.852C183.745 151.396 185.404 147.863 184.557 144.468L169.927 85.8375Z"
            fill="#FFA726"
        />
        <path
            d="M140.213 98.7926C138.364 98.1685 136.374 98.6043 134.965 99.6711C133.557 100.737 132.737 102.422 133.201 104.303C134.063 107.798 136.641 110.714 140.151 111.43C143.561 112.125 146.506 112.197 149.338 111.517C152.171 110.837 154.901 109.404 157.878 107.073C160.826 104.765 161.849 100.823 160.949 97.1721C160.541 95.516 159.144 94.57 157.537 94.3553C155.928 94.1404 154.13 94.6632 152.954 95.9238C151.141 97.8678 149.222 99.0161 147.117 99.4609C145.014 99.9054 142.738 99.6449 140.213 98.7926Z"
            fill="black"
            stroke="black"
            strokeWidth="0.238737"
        />
        <path
            d="M144.553 74.116C147.304 79.0251 148.419 82.1689 149.581 88.5357"
            stroke="black"
            strokeWidth="4.49966"
            strokeLinecap="round"
        />
        <path
            d="M135.844 77.17C138.76 82.0214 139.878 85.1642 140.872 91.5897"
            stroke="black"
            strokeWidth="4.49966"
            strokeLinecap="round"
        />
        <path
            d="M127.153 108.584L131.631 108.29L131.768 110.379L131.925 112.768L127.726 112.744L127.457 110.789L127.153 108.584Z"
            fill="black"
        />
        <path
            d="M110.776 105.762C120.635 110.306 122.205 111.618 131.768 110.379M127.153 108.584L131.631 108.29L131.925 112.768L127.726 112.744L127.153 108.584Z"
            stroke="black"
            strokeWidth="1.79518"
        />
        <path
            d="M107.194 106.057L103.013 88.3082C99.0579 71.5207 109.492 54.8402 126.318 51.0514"
            stroke="black"
            strokeWidth="3.5329"
        />
        <rect
            x="0.263858"
            y="-0.42161"
            width="16.2015"
            height="23.5206"
            rx="3.75467"
            transform="matrix(0.975527 -0.21988 -0.228667 -0.973505 102.004 118.648)"
            fill="black"
            stroke="black"
            strokeWidth="0.706579"
        />
        <path
            d="M182.135 81.6802C182.739 79.9117 182.019 77.969 180.42 77.0006C178.173 75.639 175.249 76.7767 174.482 79.29C169.239 96.4683 163.332 111.185 147.263 121.362C144.622 123.035 144.472 127.034 147.167 128.619C148.225 129.24 149.52 129.343 150.623 128.805C166.87 120.882 176.006 99.6173 182.135 81.6802Z"
            fill="#DF8603"
        />
        <path
            d="M198.278 84.0454C198.882 82.2769 198.161 80.3341 196.563 79.3658C194.315 78.0042 191.391 79.1419 190.624 81.6552C185.381 98.8335 179.475 113.55 163.406 123.727C160.765 125.4 160.615 129.399 163.31 130.984C164.368 131.605 165.663 131.708 166.765 131.171C183.012 123.248 192.148 101.982 198.278 84.0454Z"
            fill="#FFA726"
        />
        <path
            d="M207.701 50.7464L223.571 40.9803L203.952 43.2475L186.687 53.7111L207.701 50.7464Z"
            fill="#787878"
        />
        <path
            d="M203.966 44.0836L238.279 16.6914L195.632 19.8656L160.043 43.7457L203.966 44.0836Z"
            fill="#1E1E1E"
        />
        <path
            d="M204.168 44.6688L198.689 28.8247C200.415 28.2484 207.233 25.9931 212.464 26.3144C213.964 26.3896 215.174 26.6884 216.289 27.3677C217.947 28.3717 218.759 29.8319 219.41 31.0614C220.511 33.1796 222.078 36.4681 223.591 40.9632C217.117 42.1984 210.642 43.4336 204.168 44.6688Z"
            fill="#262626"
        />
        <path
            d="M204.187 44.6631L198.708 28.819C196.994 29.4319 190.24 31.8701 186.325 35.3543C185.191 36.3403 184.425 37.3222 183.967 38.5456C183.283 40.3592 183.547 42.0092 183.795 43.3778C184.237 45.7238 185.036 49.2779 186.623 53.7477C192.478 50.7195 198.332 47.6913 204.187 44.6631Z"
            fill="#353535"
        />
        <path
            d="M237.792 15.2825L238.279 16.6913L195.632 19.8655L195.164 18.5116L237.792 15.2825Z"
            fill="#353535"
        />
        <path
            d="M160.043 43.7453L159.543 42.3L195.164 18.5114L195.632 19.8652L160.043 43.7453Z"
            fill="#4C4C4C"
        />
        <path
            d="M182.695 26.8386L181.513 26.8015C180.952 26.8108 180.495 27.283 180.504 27.8444L180.825 47.2199L181.967 47.201L181.641 27.5544L182.695 26.8386Z"
            fill="#F4B142"
        />
        <path
            d="M181.139 49.5889C180.297 49.523 179.668 48.787 179.733 47.945C179.799 47.1029 180.535 46.4737 181.377 46.5395C182.219 46.6053 182.848 47.3413 182.782 48.1834C182.716 49.0254 181.98 49.6547 181.139 49.5889Z"
            fill="#F4B142"
        />
        <path
            d="M183.829 56.4014C183.229 56.6263 182.056 56.9812 180.572 56.8457C179.165 56.7163 178.135 56.228 177.577 55.9125C178.368 53.7413 179.179 51.5716 179.97 49.4004L182.434 49.6707L183.829 56.4014Z"
            fill="#F4B142"
        />
        <path
            d="M179.956 49.5749L182.31 49.7589C182.503 49.774 182.669 49.6317 182.685 49.4387C182.7 49.2457 182.557 49.0792 182.364 49.0641L180.01 48.8801C179.817 48.865 179.651 49.0073 179.636 49.2003C179.621 49.3933 179.763 49.5598 179.956 49.5749Z"
            fill="#AD7026"
        />
        <rect
            x="349.134"
            y="143.886"
            width="47.1514"
            height="24.4001"
            rx="12.2"
            fill="#2D79BC"
        />
        <rect
            x="349.134"
            y="143.886"
            width="47.1514"
            height="24.4001"
            rx="12.2"
            stroke="#2D79BC"
            strokeWidth="1.64542"
        />
        <path
            d="M359.83 161.246C359.36 161.246 358.891 161.209 358.422 161.134C357.952 161.07 357.51 160.969 357.094 160.83C356.678 160.681 356.304 160.5 355.974 160.286C355.782 160.158 355.648 160.004 355.574 159.822C355.499 159.641 355.472 159.465 355.494 159.294C355.526 159.113 355.595 158.958 355.702 158.83C355.819 158.692 355.963 158.606 356.134 158.574C356.304 158.542 356.491 158.59 356.694 158.718C357.163 158.996 357.659 159.198 358.182 159.326C358.704 159.454 359.254 159.518 359.83 159.518C360.672 159.518 361.286 159.38 361.67 159.102C362.054 158.814 362.246 158.446 362.246 157.998C362.246 157.625 362.107 157.332 361.83 157.118C361.563 156.905 361.099 156.729 360.438 156.59L358.678 156.222C357.664 156.009 356.907 155.652 356.406 155.15C355.915 154.638 355.67 153.966 355.67 153.134C355.67 152.612 355.776 152.137 355.99 151.71C356.203 151.284 356.502 150.916 356.886 150.606C357.28 150.297 357.744 150.062 358.278 149.902C358.822 149.732 359.419 149.646 360.07 149.646C360.71 149.646 361.318 149.726 361.894 149.886C362.47 150.046 362.987 150.281 363.446 150.59C363.616 150.708 363.728 150.852 363.782 151.022C363.846 151.193 363.862 151.364 363.83 151.534C363.798 151.694 363.723 151.833 363.606 151.95C363.488 152.068 363.339 152.137 363.158 152.158C362.987 152.18 362.79 152.126 362.566 151.998C362.171 151.774 361.771 151.614 361.366 151.518C360.96 151.422 360.523 151.374 360.054 151.374C359.563 151.374 359.142 151.444 358.79 151.582C358.438 151.721 358.166 151.918 357.974 152.174C357.792 152.42 357.702 152.713 357.702 153.054C357.702 153.438 357.83 153.748 358.086 153.982C358.342 154.206 358.779 154.382 359.398 154.51L361.142 154.878C362.198 155.102 362.982 155.454 363.494 155.934C364.016 156.414 364.278 157.054 364.278 157.854C364.278 158.366 364.171 158.83 363.958 159.246C363.755 159.662 363.456 160.02 363.062 160.318C362.678 160.617 362.214 160.846 361.67 161.006C361.126 161.166 360.512 161.246 359.83 161.246ZM366.835 161.214C366.515 161.214 366.27 161.129 366.099 160.958C365.929 160.777 365.843 160.521 365.843 160.19V150.686C365.843 150.356 365.929 150.105 366.099 149.934C366.27 149.764 366.515 149.678 366.835 149.678C367.155 149.678 367.401 149.764 367.571 149.934C367.753 150.105 367.843 150.356 367.843 150.686V156.59H367.875L370.515 153.806C370.729 153.593 370.915 153.428 371.075 153.31C371.235 153.193 371.454 153.134 371.731 153.134C372.009 153.134 372.217 153.209 372.355 153.358C372.505 153.497 372.579 153.668 372.579 153.87C372.579 154.073 372.483 154.276 372.291 154.478L369.507 157.422V156.59L372.563 159.886C372.755 160.089 372.841 160.297 372.819 160.51C372.809 160.713 372.723 160.884 372.563 161.022C372.403 161.15 372.201 161.214 371.955 161.214C371.657 161.214 371.417 161.156 371.235 161.038C371.065 160.921 370.873 160.745 370.659 160.51L367.875 157.598H367.843V160.19C367.843 160.873 367.507 161.214 366.835 161.214ZM376.124 164.094C375.89 164.094 375.698 164.03 375.548 163.902C375.399 163.785 375.308 163.625 375.276 163.422C375.255 163.22 375.292 163.006 375.388 162.782L376.476 160.366V161.198L373.564 154.462C373.468 154.228 373.436 154.009 373.468 153.806C373.5 153.604 373.596 153.444 373.756 153.326C373.927 153.198 374.156 153.134 374.444 153.134C374.69 153.134 374.887 153.193 375.036 153.31C375.186 153.417 375.319 153.625 375.436 153.934L377.596 159.326H377.116L379.324 153.918C379.442 153.62 379.58 153.417 379.74 153.31C379.9 153.193 380.114 153.134 380.38 153.134C380.615 153.134 380.802 153.198 380.94 153.326C381.079 153.444 381.164 153.604 381.196 153.806C381.228 153.998 381.191 154.212 381.084 154.446L377.196 163.326C377.058 163.625 376.908 163.828 376.748 163.934C376.588 164.041 376.38 164.094 376.124 164.094ZM386.262 161.246C385.377 161.246 384.614 161.081 383.974 160.75C383.334 160.42 382.838 159.95 382.486 159.342C382.145 158.734 381.974 158.014 381.974 157.182C381.974 156.372 382.139 155.662 382.47 155.054C382.811 154.446 383.275 153.972 383.862 153.63C384.459 153.278 385.137 153.102 385.894 153.102C386.449 153.102 386.945 153.193 387.382 153.374C387.83 153.556 388.209 153.817 388.518 154.158C388.838 154.5 389.078 154.916 389.238 155.406C389.409 155.886 389.494 156.43 389.494 157.038C389.494 157.23 389.425 157.38 389.286 157.486C389.158 157.582 388.971 157.63 388.726 157.63H383.59V156.478H388.086L387.83 156.718C387.83 156.228 387.755 155.817 387.606 155.486C387.467 155.156 387.259 154.905 386.982 154.734C386.715 154.553 386.379 154.462 385.974 154.462C385.526 154.462 385.142 154.569 384.822 154.782C384.513 154.985 384.273 155.278 384.102 155.662C383.942 156.036 383.862 156.484 383.862 157.006V157.118C383.862 157.993 384.065 158.649 384.47 159.086C384.886 159.513 385.494 159.726 386.294 159.726C386.571 159.726 386.881 159.694 387.222 159.63C387.574 159.556 387.905 159.433 388.214 159.262C388.438 159.134 388.635 159.081 388.806 159.102C388.977 159.113 389.11 159.172 389.206 159.278C389.313 159.385 389.377 159.518 389.398 159.678C389.419 159.828 389.387 159.982 389.302 160.142C389.227 160.302 389.094 160.441 388.902 160.558C388.529 160.793 388.097 160.969 387.606 161.086C387.126 161.193 386.678 161.246 386.262 161.246Z"
            fill="white"
        />
        <g filter="url(#filter0_d_162_2845)">
            <path
                d="M340.093 144.38L336.343 131.223C336.149 130.544 336.855 129.958 337.496 130.264L349.921 136.209C350.582 136.525 350.532 137.473 349.842 137.717L344.732 139.528C344.547 139.594 344.391 139.723 344.293 139.893L341.606 144.565C341.244 145.196 340.292 145.079 340.093 144.38Z"
                fill="#2D79BC"
            />
            <path
                d="M335.947 131.336C335.654 130.306 336.721 129.438 337.673 129.894L350.099 135.837C351.089 136.311 351.015 137.737 349.98 138.105L344.87 139.916C344.8 139.941 344.738 139.983 344.692 140.038L344.65 140.098L341.963 144.77C341.42 145.715 339.997 145.542 339.698 144.492L335.947 131.336Z"
                stroke="#2D79BC"
                strokeWidth="0.822709"
            />
        </g>
        <rect
            x="85.774"
            y="46.6134"
            width="42.9069"
            height="24.3036"
            rx="12.1518"
            transform="rotate(180 85.774 46.6134)"
            fill="#DF8603"
        />
        <rect
            x="85.774"
            y="46.6134"
            width="42.9069"
            height="24.3036"
            rx="12.1518"
            transform="rotate(180 85.774 46.6134)"
            stroke="#DF8603"
            strokeWidth="1.60935"
        />
        <path
            d="M53.2646 39.5895C52.9339 39.5895 52.6779 39.4989 52.4966 39.3175C52.3259 39.1255 52.2406 38.8589 52.2406 38.5175V33.6535L52.6726 34.8855L48.8166 29.4615C48.6779 29.2695 48.6139 29.0669 48.6246 28.8535C48.6459 28.6295 48.7366 28.4429 48.8966 28.2935C49.0566 28.1335 49.2806 28.0535 49.5686 28.0535C49.7819 28.0535 49.9739 28.1069 50.1446 28.2135C50.3259 28.3202 50.4966 28.4855 50.6566 28.7095L53.5206 32.7735H53.0726L55.9526 28.7095C56.1233 28.4749 56.2886 28.3095 56.4486 28.2135C56.6086 28.1069 56.8059 28.0535 57.0406 28.0535C57.3179 28.0535 57.5313 28.1282 57.6806 28.2775C57.8406 28.4162 57.9206 28.5922 57.9206 28.8055C57.9313 29.0189 57.8566 29.2429 57.6966 29.4775L53.8726 34.8855L54.2886 33.6535V38.5175C54.2886 39.2322 53.9473 39.5895 53.2646 39.5895ZM61.4911 39.6215C60.6804 39.6215 59.9764 39.4562 59.3791 39.1255C58.7818 38.7949 58.3178 38.3255 57.9871 37.7175C57.6564 37.0989 57.4911 36.3735 57.4911 35.5415C57.4911 34.9122 57.5818 34.3522 57.7631 33.8615C57.9551 33.3602 58.2271 32.9335 58.5791 32.5815C58.9311 32.2189 59.3524 31.9469 59.8431 31.7655C60.3338 31.5735 60.8831 31.4775 61.4911 31.4775C62.3018 31.4775 63.0058 31.6429 63.6031 31.9735C64.2004 32.3042 64.6644 32.7735 64.9951 33.3815C65.3258 33.9895 65.4911 34.7095 65.4911 35.5415C65.4911 36.1709 65.3951 36.7362 65.2031 37.2375C65.0218 37.7389 64.7551 38.1709 64.4031 38.5335C64.0511 38.8855 63.6298 39.1575 63.1391 39.3495C62.6484 39.5309 62.0991 39.6215 61.4911 39.6215ZM61.4911 38.1015C61.8858 38.1015 62.2324 38.0055 62.5311 37.8135C62.8298 37.6215 63.0591 37.3389 63.2191 36.9655C63.3898 36.5815 63.4751 36.1069 63.4751 35.5415C63.4751 34.6882 63.2938 34.0535 62.9311 33.6375C62.5684 33.2109 62.0884 32.9975 61.4911 32.9975C61.0964 32.9975 60.7498 33.0935 60.4511 33.2855C60.1524 33.4669 59.9178 33.7495 59.7471 34.1335C59.5871 34.5069 59.5071 34.9762 59.5071 35.5415C59.5071 36.3842 59.6884 37.0242 60.0511 37.4615C60.4138 37.8882 60.8938 38.1015 61.4911 38.1015ZM69.9738 39.6215C69.3232 39.6215 68.7845 39.5042 68.3578 39.2695C67.9312 39.0242 67.6112 38.6615 67.3978 38.1815C67.1952 37.7015 67.0938 37.1042 67.0938 36.3895V32.5175C67.0938 32.1762 67.1792 31.9255 67.3498 31.7655C67.5205 31.5949 67.7658 31.5095 68.0858 31.5095C68.4058 31.5095 68.6512 31.5949 68.8218 31.7655C69.0032 31.9255 69.0938 32.1762 69.0938 32.5175V36.4215C69.0938 36.9762 69.2058 37.3869 69.4298 37.6535C69.6538 37.9202 70.0112 38.0535 70.5018 38.0535C71.0352 38.0535 71.4725 37.8722 71.8138 37.5095C72.1552 37.1362 72.3258 36.6455 72.3258 36.0375V32.5175C72.3258 32.1762 72.4112 31.9255 72.5818 31.7655C72.7525 31.5949 72.9978 31.5095 73.3178 31.5095C73.6378 31.5095 73.8832 31.5949 74.0538 31.7655C74.2352 31.9255 74.3258 32.1762 74.3258 32.5175V38.5655C74.3258 39.2482 74.0005 39.5895 73.3498 39.5895C73.0405 39.5895 72.8005 39.5042 72.6298 39.3335C72.4592 39.1522 72.3738 38.8962 72.3738 38.5655V37.3495L72.5978 37.8295C72.3738 38.4055 72.0325 38.8482 71.5738 39.1575C71.1258 39.4669 70.5925 39.6215 69.9738 39.6215ZM77.3675 36.2135C77.1648 36.2135 77.0048 36.1495 76.8875 36.0215C76.7808 35.8935 76.7168 35.7122 76.6955 35.4775L76.2155 29.3655C76.1835 28.9709 76.2688 28.6562 76.4715 28.4215C76.6741 28.1762 76.9728 28.0535 77.3675 28.0535C77.7515 28.0535 78.0395 28.1762 78.2315 28.4215C78.4341 28.6562 78.5195 28.9709 78.4875 29.3655L78.0075 35.4775C77.9968 35.7122 77.9328 35.8935 77.8155 36.0215C77.7088 36.1495 77.5595 36.2135 77.3675 36.2135ZM77.3675 39.5415C77.0048 39.5415 76.7115 39.4295 76.4875 39.2055C76.2741 38.9815 76.1675 38.6935 76.1675 38.3415C76.1675 38.0002 76.2741 37.7229 76.4875 37.5095C76.7115 37.2855 77.0048 37.1735 77.3675 37.1735C77.7408 37.1735 78.0288 37.2855 78.2315 37.5095C78.4448 37.7229 78.5515 38.0002 78.5515 38.3415C78.5515 38.6935 78.4448 38.9815 78.2315 39.2055C78.0288 39.4295 77.7408 39.5415 77.3675 39.5415Z"
            fill="white"
        />
        <g filter="url(#filter1_d_162_2845)">
            <path
                d="M94.6166 46.1308L98.2848 58.9988C98.4742 59.6633 97.7841 60.237 97.1566 59.9368L85.0038 54.123C84.3577 53.8139 84.4062 52.8864 85.0811 52.6473L90.0792 50.8764C90.2607 50.8121 90.413 50.6855 90.5084 50.5195L93.1365 45.95C93.4913 45.333 94.4216 45.4467 94.6166 46.1308Z"
                fill="#DF8603"
            />
            <path
                d="M98.6721 58.8888C98.9589 59.8959 97.9139 60.7454 96.9827 60.2999L84.8304 54.4855C83.8618 54.0221 83.9334 52.6267 84.9466 52.2677L89.9446 50.4972C90.0362 50.4647 90.1122 50.4007 90.1595 50.3185L92.7874 45.7491C93.3192 44.8245 94.7104 44.9937 95.0032 46.0206L98.6721 58.8888Z"
                stroke="#DF8603"
                strokeWidth="0.804675"
            />
        </g>
        <path
            d="M6.19248 161.905C7.84334 164.647 9.17838 166.291 11.3978 168.385C11.6664 168.638 11.7062 169.053 11.4859 169.349L7.20506 175.108C6.90268 175.515 6.28582 175.492 6.02895 175.055C3.59514 170.915 3.16149 167.777 4.88913 162.049C5.06901 161.453 5.87123 161.371 6.19248 161.905Z"
            fill="#FF8F00"
        />
        <circle
            cx="23.8208"
            cy="23.8208"
            r="23.8208"
            transform="matrix(-1 0 0 1 53.3653 154.541)"
            fill="#FF8F00"
        />
        <path
            d="M14.2444 168.2L14.4632 158.016C14.5639 153.325 18.3527 149.552 23.0438 149.471L26.235 149.415C29.3637 149.361 31.9292 151.883 31.9292 155.012"
            stroke="black"
            strokeWidth="1.4043"
        />
        <rect
            x="0.234567"
            y="-0.220378"
            width="11.3568"
            height="16.4821"
            rx="2.54544"
            transform="matrix(0.999514 0.0311729 0.0311729 -0.999514 8.25604 183.907)"
            fill="black"
            stroke="black"
            strokeWidth="0.455167"
        />
        <circle
            cx="2.64676"
            cy="2.64676"
            r="2.64676"
            transform="matrix(-0.990601 0.136781 0.136781 0.990601 44.8247 168.415)"
            fill="black"
        />
        <line
            x1="0.962458"
            y1="-0.962458"
            x2="4.81229"
            y2="-0.962458"
            transform="matrix(-0.13678 -0.990601 -0.990601 0.13678 42.4007 177.251)"
            stroke="black"
            strokeWidth="1.92492"
            strokeLinecap="round"
        />
        <path
            d="M37.638 167.83C36.5949 164.206 35.655 162.171 33.291 158.532"
            stroke="black"
            strokeWidth="3.12394"
            strokeLinecap="round"
        />
        <path
            d="M31.5508 170.83C30.5077 167.206 29.5679 165.171 27.2038 161.531"
            stroke="black"
            strokeWidth="3.12394"
            strokeLinecap="round"
        />
        <path
            d="M6.78772 195.652C13.9456 200.144 17.5855 200.162 23.4421 195.934"
            stroke="#FF8F00"
            strokeWidth="4.24513"
            strokeLinecap="round"
        />
        <path
            d="M23.2661 148.928C23.5027 152.12 23.9525 154.189 24.989 157.059C25.1145 157.406 24.963 157.795 24.6326 157.96L18.2144 161.169C17.761 161.395 17.2211 161.096 17.1889 160.59C16.8841 155.798 17.9124 152.801 22.0376 148.469C22.4671 148.018 23.2201 148.306 23.2661 148.928Z"
            fill="#FF8F00"
        />
        <defs>
            <filter
                id="filter0_d_162_2845"
                x="333.84"
                y="128.535"
                width="19.0179"
                height="19.7338"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dy="0.822709" />
                <feGaussianBlur stdDeviation="0.822709" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
                />
                <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_162_2845"
                />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_162_2845"
                    result="shape"
                />
            </filter>
            <filter
                id="filter1_d_162_2845"
                x="82.1319"
                y="43.9368"
                width="18.601"
                height="19.3011"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dy="0.804675" />
                <feGaussianBlur stdDeviation="0.804675" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
                />
                <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_162_2845"
                />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_162_2845"
                    result="shape"
                />
            </filter>
        </defs>
    </svg>
);

export default IntroSessionDecoration;
